import {
  ItemInterface,
  PreferencesFormType,
  PreferenceType,
  SimpleItemInterface
} from '../types';
import { DaysMask } from './common';

export const days: ItemInterface[] = [
  {
    value: DaysMask.Sunday,
    label: 'Su',
    key: PreferenceType.SchAasPreRecWeekMask
  },
  {
    value: DaysMask.Monday,
    label: 'Mo',
    key: PreferenceType.SchAasPreRecWeekMask
  },
  {
    value: DaysMask.Tuesday,
    label: 'Tu',
    key: PreferenceType.SchAasPreRecWeekMask
  },
  {
    value: DaysMask.Wednesday,
    label: 'We',
    key: PreferenceType.SchAasPreRecWeekMask
  },
  {
    value: DaysMask.Thursday,
    label: 'Th',
    key: PreferenceType.SchAasPreRecWeekMask
  },
  {
    value: DaysMask.Friday,
    label: 'Fr',
    key: PreferenceType.SchAasPreRecWeekMask
  },
  {
    value: DaysMask.Saturday,
    label: 'Sa',
    key: PreferenceType.SchAasPreRecWeekMask
  }
];

export const PHONE_LABEL: SimpleItemInterface = { label: 'Phone', value: '1' };
export const SMS_LABEL: SimpleItemInterface = { label: 'SMS', value: '2' };
export const EMAIL_LABEL: SimpleItemInterface = { label: 'Email', value: '3' };
export const PRINT_LABEL: SimpleItemInterface = { label: 'Print', value: '4' };

export const appointmentsPriorDays: ItemInterface[] = [
  { label: '2', value: '2', key: PreferenceType.ConfirmationDaysPrior },
  { label: '3', value: '3', key: PreferenceType.ConfirmationDaysPrior },
  { label: '4', value: '4', key: PreferenceType.ConfirmationDaysPrior },
  { label: '5', value: '5', key: PreferenceType.ConfirmationDaysPrior }
];

export const preferredTimeOptions: ItemInterface[] = [
  { label: 'Any Time', value: '0', key: PreferenceType.SchAasPreferredTod },
  { label: 'Mornings', value: '1', key: PreferenceType.SchAasPreferredTod },
  { label: 'Afternoons', value: '2', key: PreferenceType.SchAasPreferredTod },
  { label: 'Evenings', value: '3', key: PreferenceType.SchAasPreferredTod }
];

export const initialFormState: PreferencesFormType = {
  [PreferenceType.ConfirmationPhone]: 0,
  [PreferenceType.ConfirmationEmail]: 0,
  [PreferenceType.ConfirmationSms]: 0,
  [PreferenceType.ConfirmationDaysPrior]: 0,
  [PreferenceType.ReminderSms]: 0,
  [PreferenceType.ReminderEmail]: 0,
  [PreferenceType.SchAasPreRecWeekMask]: 0,
  [PreferenceType.SchAasPreferredTod]: 0,
  [PreferenceType.ReceiptsInvPrint]: 0,
  [PreferenceType.ReceiptsInvSms]: 0,
  [PreferenceType.ReceiptsInvEmial]: 0,
  [PreferenceType.PrimaryPhone]: 0,
  [PreferenceType.MarketingPromoSms]: 0,
  [PreferenceType.MarketingPromoEmail]: 0
};
